import { StyleSheet } from "react-native";
const style = StyleSheet.create({
    image: {
        flex: 1,
        height: "100%",
        position: "absolute",
        width: "100%",
        zIndex: 10,
    },
    skeleton: {
        flex: 1,
    },
    view: {
        position: "relative",
    },
});
export { style };
